/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Picker_Placeholder_PropertyInputs */

const cs_entity_picker_placeholder_property = /** @type {(inputs: Entity_Picker_Placeholder_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat nemovitost (název, adresa, číslo zakázky)`)
};

const en_entity_picker_placeholder_property = /** @type {(inputs: Entity_Picker_Placeholder_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search property (title, address, listing no.)`)
};

/**
* | output |
* | --- |
* | "Search property (title, address, listing no.)" |
*
* @param {Entity_Picker_Placeholder_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_picker_placeholder_property = /** @type {((inputs?: Entity_Picker_Placeholder_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Picker_Placeholder_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_picker_placeholder_property(inputs)
	return cs_entity_picker_placeholder_property(inputs)
});